import React from 'react';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import ModuleBasicInfoComponent from './module-basic-info.component';

export const ModuleComponent = ({  
    selectLMSModules, handleInnerFormChange, back, handleFormSubmit,EntityTypeList,CollectionsList,CourseList,learningpathList
}: any) => {
    const tabItems = [
        {
            id: 1,
            title: 'Module Basic Information', 
            component: <ModuleBasicInfoComponent 
                handleInnerFormChange={handleInnerFormChange}
                selectLMSModules={selectLMSModules}  
                EntityTypeList={EntityTypeList}
                CollectionsList={CollectionsList}
                CourseList={CourseList}
                learningpathList={learningpathList}
            />,
            isVisible: true,
        },
    ]

                
    return (
        <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">

            <TabContainer tabItems={tabItems} />

            <div className='flex w-full justify-end items-end'>
                <button
                    onClick={back}
                    type='button'
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                >
                    Back
                </button>
                <button
                    className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
                    onClick={handleFormSubmit}
                    type="submit"
                >
                    Save
                </button>
            </div>
        </div>
    )
}

export default ModuleComponent;  
